import constants from "../../../../../../../../../appConstants";
import {
  MultiSelectFilter,
  StaticFilter,
} from '@dataGrid/components/columnFilters';
import { HZ_FILTER } from "../../../../../constants";
import { SpecialNeedsRenderer } from '@dataGrid/components/cellRenderer/index';
import { svcValueGetter, hazmatValueGetter } from '@dataGrid/gridUtilities';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ showTrailerScac }) {
    return GridConfig.getDefaultConfiguration(showTrailerScac);
  }
  static proIdValueGetter(props) {
    return props.data?.proId !== "0"
      ? props.data.proId
      : "";
  }

  static getCommaSeparatedPackageCode(params) {
    if (params.context.isPickupCompleted()) {
      if (!params.data.freightDescriptionDetails) {
        return '';
      }
      return params.data.freightDescriptionDetails
        .map((item) => item.packageCode)
        .filter(Boolean).join(', ');
    }
    return params.data.packageCode;
  }

  static getDefaultConfiguration(showTrailerScac) {
    return {
      title: constants.gridNames.DispatchPickupInfoGrid,
      keyColumn: "proId",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
      },
      columns: [
        {
          headerName: "Seq#",
          headerTooltip: "Sequence Number",
          colId: "seqNumber",
          field: "seq",
          valueFormatter: ({ value }) => value ? `${value}`.padStart(3, '0') : '',
          minWidth: constants.columnWidth.W_85,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          lockPosition: true,
        },
        {
          headerName: "Dest Zip",
          headerTooltip: "Destination Zip",
          field: "consigneeZip",
          minWidth: constants.columnWidth.W_95,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          lockPosition: true,
        },
        {
          headerName: "Dest Term",
          headerTooltip: "Destination Terminal",
          minWidth: constants.columnWidth.W_110,
          field: "destinationTerminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          lockPosition: true,
        },
        {
          headerName: "HU",
          headerTooltip: "Handling Unit",
          field: "hu",
          minWidth: constants.columnWidth.HU,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          lockPosition: true,
        },
        {
          headerName: "Pieces",
          field: "pieces",
          minWidth: constants.columnWidth.W_85,
          lockPosition: true,
          headerTooltip: "Pieces",
          filter: MultiSelectFilter,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Weight",
          field: "weight",
          minWidth: constants.columnWidth.W_90,
          lockPosition: true,
          headerTooltip: "Total weight",
          cellClass: "gridCell-centerAlign",
          filter: MultiSelectFilter,
        },

        {
          headerName: "Pkg Code",
          field: "packageCode",
          valueGetter: GridConfig.getCommaSeparatedPackageCode,
          headerTooltip: "Package Code",
          minWidth: constants.columnWidth.W_95,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Hz",
          headerTooltip: "Hazard",
          valueGetter: hazmatValueGetter,
          cellRendererFramework: SpecialNeedsRenderer,
          cellRendererParams: {
            options: HZ_FILTER,
          },
          filter: StaticFilter,
          filterParams: {
            staticOptions: HZ_FILTER,
          },
          minWidth: constants.columnWidth.HU,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
        },
        {
          headerName: "Cube",
          field: "cube",
          minWidth: constants.columnWidth.W_85,
          lockPosition: true,
          headerTooltip: "Cube",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Pro #",
          valueGetter: this.proIdValueGetter,
          headerTooltip: "ProNumber",
          minWidth: constants.columnWidth.PROID,
          lockPosition: true,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "SVC",
          valueGetter: svcValueGetter,
          minWidth: constants.columnWidth.W_120,
          lockPosition: true,
          headerTooltip: "Service Level",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Trailer",
          minWidth: constants.columnWidth.TRAILER_ID,
          field: "trailer",
          lockPosition: true,
          headerTooltip: "Trailer",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "scacCode",
          hide: !showTrailerScac,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
        },
      ],
    };
  }
}
